import { DateField } from '@/global/components/DateField'
import dayjs from 'dayjs'

interface DatePickerMultipleProps {
    value?: { data: Date }[]
    onChange?: (value: { data: Date }[]) => void
    label?: string
    disabled?: boolean
}

/**
 * Campo de datas múltiplas: nunca guarda valor próprio — cada escolha
 * acrescenta uma data à lista de quem chama, ignorando repetidas.
 */
export function DatePickerMultiple({
    value = [],
    onChange,
    label,
    disabled = false,
}: DatePickerMultipleProps) {
    const acrescentarData = (novaData: dayjs.Dayjs | null) => {
        if (!novaData || !onChange || !novaData.isValid()) return

        const dataParaAdicionar = novaData.utc().toDate()
        const formatada = dayjs(dataParaAdicionar).format('YYYY-MM-DD')

        // Comparação normalizada em UTC para não repetir o mesmo dia.
        const jaExiste = value.some(
            item => dayjs.utc(item.data).format('YYYY-MM-DD') === formatada,
        )
        if (jaExiste) return

        onChange([...value, { data: dataParaAdicionar }])
    }

    return (
        <DateField
            label={label}
            disabled={disabled}
            value={null}
            // Sem valor próprio não há como ressincronizar o texto depois de
            // emitir: o que fosse digitado ficaria órfão na caixa. Aqui as
            // datas entram só pelo calendário.
            permitirDigitacao={false}
            onChange={acrescentarData}
            placeholder="Selecione as datas uma por vez"
            helperText={
                value.length > 0
                    ? `${value.length} dia(s) selecionado(s)`
                    : 'Selecione as datas uma por vez'
            }
        />
    )
}
